import styled from 'styled-components'

export const Container = styled.div`
  padding: 1rem;

  h1 {
    font-size: 1.9375rem;
    line-height: 1.6875rem;
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  }

  p {
    font-size: 1rem;
    line-height: 1.375rem;
    font-weight: 500;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
  }

  @media only screen and (min-width: 900px) {
    padding-left: 300px;
    margin-top: 80px;
  }
`
